"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ResetPasswordForm, _Component);

  function ResetPasswordForm() {
    (0, _classCallCheck3.default)(this, ResetPasswordForm);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPasswordForm, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Kirjoita alle s\xE4hk\xF6postiosoitteesi, niin l\xE4het\xE4mme sinulle ohjeet salasanan vaihtamiseksi."
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.renderError(),
          this.renderSuccessMessage()
        ),
        this.renderPasswordForm()
      );
    }
  }, {
    key: "renderPasswordForm",
    value: function renderPasswordForm() {
      var _props = this.props,
          email = _props.fields.email,
          handleSubmit = _props.handleSubmit,
          _props$auth = _props.auth,
          resetSuccess = _props$auth.resetSuccess,
          resetLoading = _props$auth.resetLoading,
          onSubmit = _props.onSubmit;

      if (!resetSuccess) {
        return _react2.default.createElement(
          "form",
          { id: "resetPassword", onSubmit: handleSubmit(onSubmit) },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6 input-group" },
              _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email })
            )
          ),
          _react2.default.createElement(_SubmitButton2.default, { text: "L\xE4het\xE4", submitting: resetLoading || false })
        );
      }
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var resetError = this.props.auth.resetError;

      if (resetError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-text-js" },
            "S\xE4hk\xF6postin l\xE4hetys ep\xE4onnistui, tarkista, ett\xE4 antamasi s\xE4hk\xF6postiosoite on oikein."
          )
        );
      }
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      var resetSuccess = this.props.auth.resetSuccess;

      if (resetSuccess) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "success-message success-text-js" },
            "Salasanan palautuslinkki on l\xE4hetetty antamaasi s\xE4hk\xF6postiosoitteeseen."
          )
        );
      }
    }
  }]);
  return ResetPasswordForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp);
exports.default = ResetPasswordForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/password/ResetPasswordForm.js
 ** module id = 1169
 ** module chunks = 0
 **/